module.exports = __webpack_public_path__ + "logo_54-134e935478c9317e711d67d097978fa4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_54.png
// module id = 1141
// module chunks = 0 1